import type { AitypesInsight } from '@polaris/api-client'
import { cva, type VariantProps } from 'class-variance-authority'
import Image from 'next/image'
import { cn } from '@/src/utils/styles'

const insightVisualizationVariants = cva('w-auto h-auto object-contain', {
  variants: {
    variant: {
      fixed: 'max-w-[280px] max-h-[280px]',
      responsive: 'max-w-[min(80%,280px)] max-h-[min(80%,280px)]',
    },
  },
  defaultVariants: {
    variant: 'fixed',
  },
})

interface InsightCardVisualizationProps
  extends VariantProps<typeof insightVisualizationVariants> {
  insight: AitypesInsight
}

export const InsightCardVisualization = ({
  insight,
  variant,
}: InsightCardVisualizationProps) => {
  const visualizationComponents = {
    none: <></>,
    // We only want to show the graphics if the background is a color
    graphics: insight.backgroundType === 'color' &&
      insight.visualizationValue && (
        <Image
          src={insight.visualizationValue}
          alt='Insight card graphics'
          width={280}
          height={280}
          className={cn(insightVisualizationVariants({ variant }))}
        />
      ),
  }

  return visualizationComponents[insight.visualizationType]
}
